import axios from 'axios';
import { GET_AUDIT_LOGS, SET_AUDIT_LOG_ERROR } from './types';

export const getAuditLogs = (params) => async dispatch => {
    try {
        const response = await axios.get('/app/appConfigurations/getAuditLogs', { params });
        dispatch({ type: GET_AUDIT_LOGS, payload: response.data });
    } catch (err) {
        console.error('Error fetching audit logs:', err);
        dispatch({ type: SET_AUDIT_LOG_ERROR, payload: 'Failed to fetch audit logs' });
    }
};
